import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const purchases = [{
  name: 'María L.',
  location: 'Córdoba, Argentina'
}, {
  name: 'Juan P.',
  location: 'Santa Fe, Argentina'
}, {
  name: 'Ana M.',
  location: 'Buenos Aires, Argentina'
}, {
  name: 'Carlos R.',
  location: 'Mendoza, Argentina'
}, {
  name: 'Lucía G.',
  location: 'Entre Ríos, Argentina'
}, {
  name: 'Diego F.',
  location: 'La Pampa, Argentina'
}, {
  name: 'Sofía C.',
  location: 'Santiago del Estero, Argentina'
}, {
  name: 'Martín H.',
  location: 'Chaco, Argentina'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNextPopup();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextPopup = () => {
    const randomPurchase = purchases[Math.floor(Math.random() * purchases.length)];
    setCurrentPurchase(randomPurchase);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextDelay = Math.floor(Math.random() * 10000) + 10000;
      setTimeout(showNextPopup, nextDelay);
    }, 4000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-[slideIn_0.5s_ease-out] max-w-[280px] md:max-w-[300px]" data-id="element-265">
      <div className="bg-brand-card rounded-lg shadow-xl border-l-4 border-brand-accent p-3 flex items-start gap-2.5 relative overflow-hidden" data-id="element-266">
        <div className="bg-brand-accent/20 p-1.5 rounded-full shrink-0" data-id="element-267">
          <CheckCircle className="w-4 h-4 text-brand-accent" data-id="element-268" />
        </div>
        <div data-id="element-269">
          <p className="text-xs md:text-sm text-gray-200 font-medium leading-tight mb-0.5" data-id="element-270">
            <span className="font-bold text-white" data-id="element-271">{currentPurchase.name}</span>{' '}
            de {currentPurchase.location} acaba de comprar el Kit Completo 🌾
          </p>
          <p className="text-[10px] text-gray-500" data-id="element-272">Hace unos minutos</p>
        </div>
      </div>
      <style data-id="element-273">{`
        @keyframes slideIn {
          from { transform: translateX(-120%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
    </div>;
}